import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MapPin, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { scrollToId } from "@/lib/site";
import { useLang } from "@/lib/lang";

const SALONE_IMG =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_legal-studio-14/artifacts/dnhvuw3s_image_20260930_102357.jpg";

export default function Sede() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section data-testid="sede-section" id="sede" className="relative overflow-hidden bg-navy-deep">
      <div ref={ref} className="noise relative flex min-h-[85vh] items-center overflow-hidden">
        <motion.div style={{ y }} className="absolute inset-0 -top-20 -bottom-20" aria-hidden="true">
          <img src={SALONE_IMG} alt="" className="h-full w-full object-cover opacity-80" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-deep/90 via-navy-deep/35 to-navy-deep/70" />
        </motion.div>

        <div className="relative z-10 mx-auto w-full max-w-[1400px] px-6 py-24 lg:px-12">
          <Reveal className="max-w-lg">
            <Overline light>{t.sede.overline}</Overline>
            <h2 className="mt-4 font-serif text-4xl font-medium tracking-tight text-alabaster sm:text-5xl lg:text-6xl">
              {t.sede.title}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-alabaster/75 sm:text-lg">{t.sede.text}</p>
            <p className="mt-8 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.22em] text-gold">
              <MapPin size={14} strokeWidth={1.5} />
              {t.sede.caption}
            </p>
            <button
              data-testid="sede-cta"
              onClick={() => scrollToId("contatti")}
              className="group mt-10 flex items-center gap-3 border border-alabaster/30 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.22em] text-alabaster transition-all duration-500 hover:border-gold hover:text-gold"
            >
              {t.sede.cta}
              <ArrowRight size={13} strokeWidth={1.5} className="transition-transform duration-500 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </div>

    </section>
  );
}
